module.exports = __webpack_public_path__ + "static/media/IOTSU_L2_EPD01.d66a39eb.jpg";